export const ErrorBannerValues = {
  rateLimit: "rateLimit",
  forbidden: "forbidden",
  unknown: "unknown",
  // 400s from a bad URL the user typed (invalid id/classId/targetId/channelId). Deliberately
  // separate from `unknown` so it doesn't pollute that bucket and can be excluded from app_broken.
  badRequest: "badRequest",
  notFound: "notFound",
  apiDown: "apiDown",
  loggedOut: "loggedOut",
  apiDownLoadShedding: "apiDown-loadShedding",
  realtimeSync: "realtimeSync",
  requestBlocked: "requestBlocked",
  studentsNotInClass: "studentsNotInClass",
  moduleLoadError: "moduleLoadError",
  homeIslands: "homeIslands",
  homeIslandsLoggedOut: "homeIslandsLoggedOut",
  noNetwork: "noNetwork",
} as const;
export type ErrorBannerValue = (typeof ErrorBannerValues)[keyof typeof ErrorBannerValues];
